function initHeroTestimonials() {
  const sliders = document.querySelectorAll('[data-hero-slider]');

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll('[data-slide]');
    const prevBtn = slider.parentElement.querySelector('[data-prev]');
    const nextBtn = slider.parentElement.querySelector('[data-next]');
    const dots = slider.parentElement.querySelectorAll('[data-dot]');

    let currentIndex = 0;
    let autoplayInterval;

    function showSlide(index) {
      // Remove active class from all slides
      slides.forEach((slide) => {
        slide.classList.remove('active');
      });

      // Remove active class from all dots
      dots.forEach((dot) => {
        dot.classList.remove('active');
      });

      // Add active class to current slide and dot
      if (slides[index]) {
        slides[index].classList.add('active');
      }
      if (dots[index]) {
        dots[index].classList.add('active');
      }

      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function prevSlide() {
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(prevIndex);
    }

    function startAutoplay() {
      if (slides.length > 1) {
        autoplayInterval = setInterval(nextSlide, 5000);
      }
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
      }
    }

    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        stopAutoplay();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        stopAutoplay();
        startAutoplay();
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        stopAutoplay();
        startAutoplay();
      });
    });

    // Keyboard navigation
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
        stopAutoplay();
        startAutoplay();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        stopAutoplay();
        startAutoplay();
      }
    });

    // Pause autoplay on hover
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    // Initialize first slide
    showSlide(0);
    startAutoplay();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroTestimonials);
} else {
  initHeroTestimonials();
}
